<template>
	<div :class="[ `mode-${mode}`, hasError ? 'has-error' : '' ]" class="checkbox-container">
		<input :id="checkboxId" :checked="value" type="checkbox" @change="changeHandler">
		<label :for="checkboxId" class="checkbox-checkmark" :class="{ inactive }" />
		<label v-if="!innerHtmlLabel" :for="checkboxId" class="pointer">{{ label }}</label>
		<label v-else :for="checkboxId" class="pointer" v-html="label" />
	</div>
</template>

<script>
import { uniqueKey } from '~/assets/util/helpers'

export default {
	name: 'Checkbox',
	props: {
		value: {
			type: Boolean,
			default: false
		},
		label: {
			type: String,
			default: ''
		},
		mode: {
			type: String,
			default: 'checkbox',
			validator: value => ['checkbox', 'switcher'].includes(value)
		},
		inactive: {
			type: Boolean,
			default: false
		},
		hasError: {
			type: Boolean,
			default: false
		},
		innerHtmlLabel: {
			type: Boolean,
			default: false
		}
	},
	data () {
		return {
			checkboxId: uniqueKey()
		}
	},
	methods: {
		changeHandler () {
			this.$emit('input', !this.value)
		}
	}
}
</script>

<style lang="scss">
.events-checkbox.checkbox-container {
    width: 14px;
    height: 14px;
    margin: 8px 13px 8px 0;
    opacity: 0.5;
    border-radius: 3.2px;
    border: solid 0.8px $white;
    .checkbox-checkmark {
		border: unset !important;
		&:after {
			border-color: $white !important;
		}
		&.inactive:after {
			display: none;
		}
    }
}
.checkbox-container.has-error .checkbox-checkmark {
	box-shadow: 0 0 1px 1px #b70101;
}
</style>
